import React, { forwardRef, useEffect, useImperativeHandle, useState, useRef } from "react";
import { Menu, Icon } from "semantic-ui-react";

import { statusMapping, VISIBLE_INVOICE_STATUSES } from "../components/status";

const StatusFilter = (props, ref) => {
    const mounted = useRef(false);
    const [filterText, setFilterText] = useState(null);

    useImperativeHandle(ref, () => {
        return {
            doesFilterPass(params) {
                return params.data.status === filterText;
            },

            isFilterActive() {
                return filterText != null;
            },

            getModel() {
                if (!this.isFilterActive()) {
                    return null;
                }

                return { filterType: "text", type: "contains", filter: filterText };
            },

            setModel(model) {
                setFilterText(model == null ? null : model.filter);
            },
        };
    });

    useEffect(() => {
        if (mounted.current) {
            props.filterChangedCallback();
        } else {
            mounted.current = true;
        }
    }, [filterText]);

    const selectStatus = status => {
        if (status === filterText) {
            setFilterText(null);
        } else {
            setFilterText(status);
        }
    };

    return (
        <div>
            <Menu vertical>
                {VISIBLE_INVOICE_STATUSES.map(key => (
                    <div
                        className={`lp-15 rp-10 tp-10 bp-10 clickable ${
                            key === filterText ? "bg-lightgrey" : ""
                        }`}
                        key={key}
                        onClick={() => selectStatus(key)}
                    >
                        <Icon name={statusMapping[key].icon} color="grey" />
                        <span className="lp-15">{statusMapping[key].text}</span>
                    </div>
                ))}
            </Menu>
        </div>
    );
};

export default forwardRef(StatusFilter);
